<template>
  <div>
    <h1 style="text-align: center; color: #E94F0A">
      {{ itemData ? $t('ticket_types.edit_ticket') : $t('ticket_types.add_new') }}
    </h1>
    <div class="container">
      <div class="form" v-if="ticket.price_rule_type">
        <tooltip v-show="filedErrors.hasOwnProperty('price_rule_type')" class="form__validation">
          {{ $t('errors.field_required') }}
        </tooltip>
        <div class="label">{{ $t('ticket_types.type') }} *</div>
        <el-select style="height: 40px" name="priceRuleType" placeholder="" @change="changeType"
          v-model="ticket.price_rule_type">
          <el-option :value="FIXED" label="Fixed time durations" />
          <el-option :value="PICKER" label="Picker input" />
          <el-option :value="FIXED_ENTRY" label="Fixed entry" />
        </el-select>
      </div>
      <component :is="ExtraFields" :subData="itemData ? itemData.pricing_rule : null" />
      <div class="form al">
        <tooltip v-show="filedErrors.hasOwnProperty('available_amount')" class="form__validation">
          {{ $t('errors.field_required') }}
        </tooltip>
        <div class="label">{{ $t('ticket_types.available_amount') }} *</div>
        <input type="text" class="ticketsAmount" placeholder="20" name="availableAmount"
          @focusout="setTicketData('available_amount', $event.target.value)"
          :value="itemData ? itemData.availability : ''" />
      </div>
      <input type="checkbox" class="item-wrapper__checkbox" :checked="itemData ? itemData.id_code_enabled : false"
        @change="setTicketData('id_code_enabled', $event.target.checked)" />
      <span class="label">{{ $t('ticket_types.ask_for_id_code') }}</span>
      <div class="select-container">
        <div class="label">{{ $t('ticket_types.select_icon') }}</div>
        <el-select style="height: 40px" name="icon" :placeholder="$t('ticket_types.select_icon')" @change="changeIcon"
          v-model="ticket.icon">
          <el-option :value="''" label="No icon" />
          <el-option :value="'cargo'" label="cargo" />
          <el-option :value="'slip_usage'" label="slip usage" />
          <el-option :value="'watercraft'" label="watercraft" />
          <el-option :value="'tent'" label="tent" />
          <el-option :value="'harbour'" label="harbour" />
          <el-option :value="'auto'" label="auto" />
          <el-option :value="'caravan'" label="caravan" />
          <el-option :value="'client'" label="client" />
          <el-option :value="'cruise'" label="cruise" />
        </el-select>
      </div>
      <hr />
      <div :style="{ marginBottom: '16px' }">
        {{ $t('Now add ticket name and description and their translations') }}:
      </div>

      <LangTabsBlock />

      <input type="hidden" :value="itemData ? itemData.id : null" name="id" />
    </div>
  </div>
</template>

<script>

import '../styles.scss'
import FixedTypeExtraFields from './ExtraFields/fixed'
import PickerTypeExtraFields from './ExtraFields/picker'
import FixedEntryTypeExtraFields from './ExtraFields/fixedEntry'
import { storeMixin } from '../mixins/storeMixin.js'
import Tooltip from '../../../common/Tooltip';
import { mapGetters } from "vuex";
import { configData } from "../mixins/configData"
import LangTabsBlock from "./LangTabsBlock";

export default {
  mixins: [storeMixin, configData],
  props: ['itemData'],
  components: {
    FixedTypeExtraFields,
    PickerTypeExtraFields,
    FixedEntryTypeExtraFields,
    Tooltip,
    LangTabsBlock
  },
  created() {
    this.changeType()
    if (this.itemData) {
      this.setTicketDataToState(this.itemData)
    }
    this.ticket.price_rule_type = this.itemData ? this.itemData.price_rule_type : this.FIXED
    this.ticket.icon = this.itemData ? this.itemData.icon : null
    this.changeType()
    this.changeIcon()
  },
  computed: {
    ...mapGetters({
      filedErrors: 'tenants/ticketTypes/filedErrors',
    })
  },
  data() {
    return {
      ticket: {
        name: null,
        description: null,
        price_rule_type: null,
        icon: null
      },
      ExtraFields: FixedTypeExtraFields,
    }
  },
  methods: {
    changeType() {
      if (this.ticket.price_rule_type === this.PICKER) {
        this.ExtraFields = PickerTypeExtraFields
      } else if (this.ticket.price_rule_type === this.FIXED) {
        this.ExtraFields = FixedTypeExtraFields
      } else if (this.ticket.price_rule_type === this.FIXED_ENTRY) {
        this.ExtraFields = FixedEntryTypeExtraFields
      }
      this.setTicketData('price_rule_type', this.ticket.price_rule_type)
    },
    changeIcon() {
      this.setTicketData('icon', this.ticket.icon)
    },
    setTicketDataToState(itemData) {
      this.setTicketData('id', itemData.id)
      this.setTicketData('kioskId', itemData.kioskId)
      this.setTicketData('name', itemData.name)
      this.setTicketData('description', itemData.description)
      this.setTicketData('price_rule_type', itemData.price_rule_type)
      this.setTicketData('available_amount', itemData.availability)
      this.setTicketData('time_cost', itemData.pricing_rule.rules_string)
      this.setTicketData('unit_type', itemData.pricing_rule.unit_type)
      this.setTicketData('unit_price', itemData.pricing_rule.unit_price / 100)
      this.setTicketData('id_code_enabled', itemData.id_code_enabled)
      this.setTicketData('icon', itemData.icon)
      this.setTicketData('entries', itemData.entries)
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/tenants/ticket-types/ui/TypeForm.vue